// extracted by mini-css-extract-plugin
export default {"text":"Me_text__GzUGJ"};